import { useState } from "react"
import axiosInstance from "../../../../services/axios-client"
import { toast } from "react-toastify"
import { redirect, useNavigate } from "react-router-dom"

const useGroupBuForm = () => {
    const [payload, setPayload] = useState({
        ID: null,
        GroupName: '',
        Status: undefined,
    })
    const status = [{ 'label': 'Active', 'value': true }, { 'label': 'Inactive', 'value': false }]
    const [isSaving, setIsSaving] = useState(false)
    const navigate = useNavigate()

    const onChangeHandler = (e) => {
        setPayload({ ...payload, [e.target.name]: e.target.value })
    }

    const handleSelectStatus = (value) => {
        setPayload({
            ...payload,
            Status: value
        })
    };

    const postGbuForm = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let res = await axiosInstance.post('/auth/group-business-units', payload)
            if (res.status === 200) {
                toast.success("Success Add Group Business Unit")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
            navigate('/bu-management/1')
        }
    }

    const putGbuForm = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            let res = await axiosInstance.put('/auth/group-business-units', payload)
            if (res.status === 200) {
                toast.success("Success Update Group Business Unit")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
            navigate('/bu-management/1')
        }
    }

    const getGbuForm = async (id) => {
        try {
            let res = await axiosInstance.get(`/auth/group-business-units/${id}`)
            if (res.status === 200) {
                setPayload(res.data.data)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    return {
        payload,
        postGbuForm,
        putGbuForm,
        onChangeHandler,
        getGbuForm,
        status,
        isSaving,
        handleSelectStatus
    }
}

export default useGroupBuForm